enum LogEventContexts {
  user = 'user',
  contact = 'contact',
  exclusion = 'exclusion',
}

type LogEventContext = keyof typeof LogEventContexts;

enum LogEvents {
  login = 'login',
  logout = 'logout',
  validateAccess = 'validateAccess',
  registerExclusion = 'registerExclusion',
  sendMessage = 'sendMessage',
  sendGratefulMessage = 'sendGratefulMessage',
  viewForms = 'viewForms',
  finalizeForms = 'finalizeForms',
  confirmContact = 'confirmContact',
  noConfirmContact = 'noConfirmContact',
  successfullyContact = 'successfullyContact',
}

type LogEvent = keyof typeof LogEvents;

type LogModel = {
  createdAt: string;
  user: string;
  context: LogEventContext;
  event: LogEvent;
  detail?: any;
};

export { LogEventContexts, LogEvents };
export type { LogModel };
